import type { DealerAssignmentSummary } from '../types/map.types';

/**
 * Assignment progress for a dealer, expressed over ACTIONABLE work only:
 * handled / (handled + workable-unassigned). Advance-notice / paused recalls
 * are excluded upstream, so they don't drag the percentage down.
 *
 * Single source of truth shared by the map bubble ring (WorkingMap) and the
 * dealer cards in the right-side panel, so the two can never disagree.
 */
export interface DealerProgress {
  /** Recalls actioned (in a route, assigned, or staged). */
  handled: number;
  /** Workable recalls in scope: handled + still-waiting. */
  actionable: number;
  /** handled / actionable as a 0–100 percentage (0 when nothing is actionable). */
  pctHandled: number;
  /** True when there is actionable work and none of it is still waiting. */
  fullyHandled: boolean;
}

export function getDealerProgress(summary?: DealerAssignmentSummary): DealerProgress {
  const handled = summary?.handled ?? 0;
  const actionable = summary ? summary.handled + summary.unassigned : 0;
  return {
    handled,
    actionable,
    pctHandled: actionable > 0 ? (handled / actionable) * 100 : 0,
    fullyHandled: summary?.fullyHandled ?? false
  };
}
